import * as React from "react";
import {Paper} from "@mui/material";

import CommonUtils from "../../base/utils/CommonUtils";
import {useEffect, useState} from "react";
import Api, {APIs} from "../../../Api";
import DADataGrid from "../../digitalarz/data-grid/container/DataGrid";


const ProjectDelays = () => {
    const rowPadding = 12;
    const paperHeight = CommonUtils.getPaperHeight(0, rowPadding)
    // const [resultText, setResultText] = useState<string>("")
    const [columns, setColumns] = useState([])
    const [rows, setRows] = useState([])
    useEffect(() => {
        if (columns.length === 0 && rows.length === 0) {
            Api.get(APIs.EAD_PROJECT_DELAY).then((payload) => {
                if (payload) {
                    setColumns(payload.columns);
                    setRows(payload.rows);
                }
            });
        }
    }, []);

    return (
        <React.Fragment>
            <div className={"row"} style={{padding: rowPadding}}>
                <div className={"col-sm-12 col-md-12"}>
                    <Paper elevation={6} style={{padding: 10, height: paperHeight, overflow: "auto"}}>
                        <DADataGrid data={rows} columns={columns} title={"Project Delay"} tableHeight={paperHeight}
                                    tableWidth={1300}/>
                    </Paper>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ProjectDelays
